document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector(`.giftguide-blocks .swiper`);

  const isMobile = () => window.innerWidth < 1024;
  let swiper;

  function ensureIndicator() {
    const pag = document.querySelector(`.giftguide-blocks .swiper-pagination`);
    if (!pag) return null;
    let indicator = pag.querySelector('.pagination-indicator');

    if (isMobile()) {
      if (!indicator) {
        pag.innerHTML = `<span class="pagination-indicator tw-absolute tw-left-0 tw-top-0 tw-h-full tw-rounded-x10 tw-bg-[#120C0C]"></span>`;
        indicator = pag.querySelector('.pagination-indicator');
      }
      return indicator;
    } else {
      if (indicator) indicator.remove();
      return null;
    }
  }

  function updateIndicator(swiper) {
    const indicator = ensureIndicator();
    if (!isMobile() || !indicator) return;

    const total = swiper.virtualSize || 0;
    const viewport = swiper.size || 0;
    const widthPct = total > 0 ? (viewport / total) * 100 : 100;
    const leftPct = total > viewport ? swiper.progress * (100 - widthPct) : 0;

    indicator.style.width = `${widthPct}%`;
    indicator.style.left = `${leftPct}%`;
  }

  function initSwiper() {
    if (swiper) return;

    swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      watchOverflow: true,

      on: {
        init(swiper) {
          ensureIndicator();
          updateIndicator(swiper);
        },
        progress(swiper) {
          if (isMobile()) updateIndicator(swiper);
        },
        resize(swiper) {
          ensureIndicator();
          updateIndicator(swiper);
        },
        slidesLengthChange(swiper) {
          if (isMobile()) updateIndicator(swiper);
        }
      }
    });

    swiper.on('slideChange', swiper => {
      calculateScrollPercentage(swiper, `.giftguide-blocks .tw-capsule-title`);
    });
  }

  function destroySwiper() {
    if (!swiper) return;
    swiper.destroy(true, true);
    swiper = null;

    const indicator = document.querySelector(
      `.giftguide-blocks .pagination-indicator`
    );
    if (indicator) indicator.remove();
  }

  function checkWidthAndToggle() {
    if (isMobile()) {
      initSwiper();
    } else {
      destroySwiper();
    }
  }

  checkWidthAndToggle();

  window.addEventListener('resize', checkWidthAndToggle);
});
